/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimPresentPositions
 */
export interface ClaimPresentPositions {
    /**
     * 
     * @type {any}
     * @memberof ClaimPresentPositions
     */
    id: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimPresentPositions
     */
    claimPresentPosition: string | null;
}

/**
 * Check if a given object implements the ClaimPresentPositions interface.
 */
export function instanceOfClaimPresentPositions(value: object): value is ClaimPresentPositions {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimPresentPosition' in value) || value['claimPresentPosition'] === undefined) return false;
    return true;
}

export function ClaimPresentPositionsFromJSON(json: any): ClaimPresentPositions {
    return ClaimPresentPositionsFromJSONTyped(json, false);
}

export function ClaimPresentPositionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPresentPositions {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimPresentPosition': json['claimPresentPosition'],
    };
}

export function ClaimPresentPositionsToJSON(value?: ClaimPresentPositions | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'claimPresentPosition': value['claimPresentPosition'],
    };
}

